import { ChangeEvent, Dispatch, SetStateAction, useState } from "react";
import UnForm from "../../../../Components/Form";
import { MoneyReaisFieldMask } from "../../../../Validations/InputMasks";
import { FormProvider, useForm } from "react-hook-form";
import { IListagemDeCustos } from "../../../../Interfaces/AssistenciaTecnica/CustoOficialRelatoriosBI/CustoOficialRelatoriosBI";
import { faEdit, faPlus } from "@fortawesome/free-solid-svg-icons";
import useAsyncEffect from "../../../../hooks/useAsyncEffect";
import {
    AtualizacaoDeCustosController,
    CadastroDeCustosController,
    getCustosController,
} from "../../../../Controllers/AssistenciaTecnica/CustoOficialRelatoriosBI/CustoOficialRelatoriosBIController";
import useAsyncCallback from "../../../../hooks/useAsyncCallback";
import { formatMoneyReais } from "../../../../Tools/FormatTools";
import OrSpinner from "../../../../Components/Utils/OrSpinner";
import { ListarUsuariosController } from "../../../../Controllers/Geral/GestaoUsuarios/UsuariosController";
import { DatePicker } from "antd";
import moment, { Moment } from "moment";

interface ICreateUpdateCustoOficial {
    row?: IListagemDeCustos;
    setShow: Dispatch<SetStateAction<boolean>>;
    ListagemDeCustos: (...args: any[]) => Promise<IListagemDeCustos[]>;
}

export default function CreateUpdateCustoOficial(
    props: ICreateUpdateCustoOficial
) {
    const formMethods = useForm<IListagemDeCustos>();
    const { execute: CadastroDeCustos, loading: CadastroDeCustosLoading } =
        useAsyncCallback(CadastroDeCustosController);

    const {
        execute: AtualizacaoDeCustos,
        loading: AtualizacaoDeCustosLoading,
    } = useAsyncCallback(AtualizacaoDeCustosController);

    const { value: getCustos, loading: getCustosLoading } =
        useAsyncEffect(async () => {
            if (props.row) {
                const res = await getCustosController(props.row.ID);
                return res;
            }
        }, [props.row]);

    function geradorMascaraFinanceira(inputName: keyof IListagemDeCustos) {
        return (e: ChangeEvent<HTMLInputElement>) => {
            const mask = MoneyReaisFieldMask(e);
            formMethods?.setValue(inputName, mask);
        };
    }

    const [ano, setAno] = useState<string>(String(getCustos?.ANO ?? ""));

    function onChange(date: Moment | null, dateString: string) {
        setAno(dateString);
    }

    const [mes, setMes] = useState<string>(String(getCustos?.MES ?? ""));

    function onChangeMes(date: Moment | null, dateString: string) {
        setMes(dateString);
    }

    function handleCreateUpdateCustoOficial(formData: IListagemDeCustos) {
        if (props.row) {
            AtualizacaoDeCustos([
                {
                    ...formData,
                    ID: props.row.ID,
                    MES: mes ? mes : getCustos?.MES ?? "",
                    ANO: ano ? ano : getCustos?.ANO ?? "",
                    ID_OFICIAL_FUNCIONARIO:
                        formData.ID_OFICIAL_FUNCIONARIO.value,
                },
            ]).then(() => {
                props.setShow(false);
                props.ListagemDeCustos();
            });
        } else {
            CadastroDeCustos({
                ...formData,
                MES: mes ? mes : getCustos?.MES ?? "",
                ANO: ano ? ano : getCustos?.ANO ?? "",
                ID_OFICIAL_FUNCIONARIO: formData.ID_OFICIAL_FUNCIONARIO.value,
            }).then(() => {
                props.setShow(false);
                props.ListagemDeCustos();
            });
        }
    }

    const isLoading = CadastroDeCustosLoading || AtualizacaoDeCustosLoading;

    return (
        <OrSpinner loading={getCustosLoading} spinner="capys">
            <FormProvider {...formMethods}>
                <UnForm handleSubmit={handleCreateUpdateCustoOficial}>
                    <div className="row">
                        <div className="col-md-6">
                            <UnForm.LazySelect
                                label="Funcionário oficial"
                                name="ID_OFICIAL_FUNCIONARIO"
                                controller={ListarUsuariosController}
                                getKeyValue={(u) => u.ID_USUARIO}
                                getDS={(u) => u.DS_NOME}
                                defaultValue={getCustos?.ID_OFICIAL_FUNCIONARIO}
                                registerOptions={{
                                    required:
                                        "Selecione um funcionário oficial",
                                }}
                            >
                                <option></option>
                            </UnForm.LazySelect>
                        </div>

                        <div className="col-md-6">
                            <UnForm.Input
                                label="Valor Final"
                                name="VL_FINAL"
                                registerOptions={{
                                    setValueAs: (v: string) => {
                                        return Number(
                                            MoneyReaisFieldMask.unMask(v)
                                        );
                                    },
                                    required: "Insira um valor",
                                }}
                                onChange={geradorMascaraFinanceira("VL_FINAL")}
                                defaultValue={formatMoneyReais(
                                    getCustos?.VL_FINAL ?? 0
                                )}
                            />
                        </div>

                        <div className="col-md-6">
                            <label>Mês</label>
                            <DatePicker
                                picker="month"
                                onChange={onChangeMes}
                                className="form-control"
                                defaultValue={
                                    getCustos?.MES
                                        ? moment(
                                              getCustos?.MES.toString(),
                                              "MM"
                                          )
                                        : undefined
                                }
                                placeholder=""
                                format={"MM"}
                            />
                        </div>

                        <div className="col-md-6">
                            <label>Ano</label>
                            <DatePicker
                                picker="year"
                                onChange={onChange}
                                className="form-control"
                                defaultValue={
                                    getCustos?.ANO
                                        ? moment(
                                              getCustos?.ANO.toString(),
                                              "YYYY"
                                          )
                                        : undefined
                                }
                                placeholder=""
                            />
                        </div>
                        <div className="col-md-12">
                            <UnForm.SubmitButton
                                className="w-100 mt-5"
                                type="submit"
                                color={props.row ? "primary" : "success"}
                                icon={props.row ? faEdit : faPlus}
                                wrapperClassName="w-100"
                                loading={isLoading}
                                disabled={isLoading}
                                loadingSize={"sm"}
                            >
                                {props.row ? "Editar" : "Salvar"}
                            </UnForm.SubmitButton>
                        </div>
                    </div>
                </UnForm>
            </FormProvider>
        </OrSpinner>
    );
}
